
(function() {
  var result = { translations: { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.970"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.970",
    "ar-eg": "static-7.970",
    "bg": "static-7.970",
    "bn": "static-7.970",
    "ca-es": "static-7.970",
    "cs": "static-7.970",
    "da": "static-7.970",
    "de": "static-7.970",
    "el": "static-7.970",
    "en-gb": "static-7.970",
    "en": "static-7.970",
    "es-mx": "static-7.970",
    "es": "static-7.970",
    "fi": "static-7.970",
    "fr-ca": "static-7.970",
    "fr": "static-7.970",
    "he-il": "static-7.970",
    "hr": "static-7.970",
    "hu": "static-7.970",
    "id": "static-7.970",
    "it": "static-7.970",
    "ja": "static-7.970",
    "ko": "static-7.970",
    "lt": "static-7.970",
    "ms": "static-7.970",
    "nl": "static-7.970",
    "no": "static-7.970",
    "pl": "static-7.970",
    "pt-br": "static-7.970",
    "pt-pt": "static-7.970",
    "ro": "static-7.970",
    "ru": "static-7.970",
    "sk": "static-7.970",
    "sl": "static-7.970",
    "sv": "static-7.970",
    "th": "static-7.970",
    "tl": "static-7.970",
    "tr": "static-7.970",
    "uk": "static-7.970",
    "vi": "static-7.970",
    "x-pseudo": "static-7.970",
    "zh-cn": "static-7.970",
    "zh-hk": "static-7.970",
    "zh-tw": "static-7.970"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.970'}); }
})();


